import { render, staticRenderFns } from "./BillExtract.vue?vue&type=template&id=192c727a"
import script from "./BillExtract.vue?vue&type=script&lang=js"
export * from "./BillExtract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports